// Uses the existing Shopify privacy dialog; does not set or grant consent itself.
document.addEventListener('click',async function(event){
 const button=event.target instanceof Element?event.target.closest('[data-pci-cookie-preferences]'):null;
 if(!button)return;
 const status=button.parentElement.querySelector('[data-pci-cookie-status]');
 status.hidden=true;button.disabled=true;
 try{
  if(typeof window.privacyBanner?.showPreferences!=='function')throw new Error('Privacy controls not loaded');
  await window.privacyBanner.showPreferences();
 }catch{
  status.textContent='Die Cookie-Einstellungen sind gerade nicht verfügbar. Bitte laden Sie die Seite erneut oder kontaktieren Sie info@pc-int.de.';
  status.hidden=false;
 }finally{button.disabled=false;}
});
